export default "__VITE_ASSET__DnNqnUbk__"